import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "d-flex justify-space-between text-caption mb-1" }
const _hoisted_3 = { class: "d-flex justify-end gap-2 mt-1" }
const _hoisted_4 = { class: "d-flex align-center mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_range_slider = _resolveComponent("v-range-slider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.open,
    "max-width": "960px",
    scrollable: "",
    persistent: "",
    "onUpdate:modelValue": _ctx.onDialogUpdate
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("span", null, "Video To Agent", -1)),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "text",
                size: "small",
                disabled: _ctx.processing,
                onClick: _ctx.closeDialog
              }, null, 8, ["disabled", "onClick"])
            ]),
            _: 1,
            __: [4]
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, { class: "pt-4" }, {
            default: _withCtx(() => [
              _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-body-2 mb-4" }, " Upload a short video showing the agent action or workflow you want to replicate. Optionally trim the clip to just the relevant section before processing. ", -1)),
              (_ctx.processing)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    type: "warning",
                    density: "compact",
                    variant: "outlined",
                    class: "mb-4"
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode(" Do not refresh the page, navigate away, or close this dialog while a workflow video is in progress. The current video-processing state will be lost if the page reloads. ")
                    ])),
                    _: 1,
                    __: [5]
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_file_input, {
                "model-value": _ctx.selectedFile,
                accept: "video/mp4,video/quicktime,video/x-matroska,video/webm,video/x-msvideo,video/mp2t,video/mxf,video/x-flv,video/x-m4v,video/3gpp,video/3gpp2,.mp4,.mov,.mkv,.webm,.avi,.mxf,.flv,.m4v,.3gp,.3g2",
                label: "Workflow Video",
                "prepend-icon": "mdi-video-outline",
                variant: "outlined",
                density: "comfortable",
                "show-size": "",
                "hide-details": "",
                "onUpdate:modelValue": _ctx.onFileSelected
              }, null, 8, ["model-value", "onUpdate:modelValue"]),
              (_ctx.errorMessage)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 1,
                    type: "error",
                    density: "compact",
                    variant: "tonal",
                    class: "mt-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.videoPreviewUrl)
                ? (_openBlock(), _createBlock(_component_v_card, {
                    key: 2,
                    variant: "outlined",
                    class: "mt-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("video", {
                            ref: "previewVideo",
                            src: _ctx.videoPreviewUrl,
                            controls: "",
                            class: "video-to-agent-preview",
                            onLoadedmetadata: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLoadedMetadata && _ctx.onLoadedMetadata(...args))),
                            onTimeupdate: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onVideoTimeUpdate && _ctx.onVideoTimeUpdate(...args)))
                          }, null, 40, _hoisted_1),
                          _createVNode(_component_v_row, {
                            class: "mt-2",
                            density: "compact"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, [
                                    _cache[6] || (_cache[6] = _createElementVNode("span", null, "Clip in/out", -1)),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.formatTime(_ctx.clipRange[0])) + " - " + _toDisplayString(_ctx.formatTime(_ctx.clipRange[1])), 1)
                                  ]),
                                  _createVNode(_component_v_range_slider, {
                                    "model-value": _ctx.clipRange,
                                    min: 0,
                                    max: _ctx.durationSec,
                                    step: 0.1,
                                    color: "primary",
                                    "track-color": "secondary",
                                    "hide-details": "",
                                    "onUpdate:modelValue": _ctx.updateClipRange
                                  }, null, 8, ["model-value", "max", "onUpdate:modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_v_btn, {
                              variant: "text",
                              disabled: _ctx.processing,
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.jumpToClipBoundary('start')))
                            }, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode(" Jump To In ")
                              ])),
                              _: 1,
                              __: [7]
                            }, 8, ["disabled"]),
                            _createVNode(_component_v_btn, {
                              variant: "text",
                              disabled: _ctx.processing,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.jumpToClipBoundary('end')))
                            }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode(" Jump To Out ")
                              ])),
                              _: 1,
                              __: [8]
                            }, 8, ["disabled"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.processing)
                ? (_openBlock(), _createBlock(_component_v_card, {
                    key: 3,
                    variant: "outlined",
                    class: "mt-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_v_icon, { class: "mr-2" }, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createTextVNode("mdi-progress-clock")
                              ])),
                              _: 1,
                              __: [9]
                            }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.processingLabel), 1)
                          ]),
                          _createVNode(_component_v_progress_linear, {
                            indeterminate: "",
                            color: "primary",
                            height: "6"
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1,
            __: [10]
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_actions, { class: "px-4 py-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "text",
                disabled: _ctx.processing,
                onClick: _ctx.closeDialog
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode(" Close ")
                ])),
                _: 1,
                __: [11]
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                disabled: _ctx.processing || !_ctx.canProcess,
                onClick: _ctx.emitProcess
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode(" Process Video ")
                ])),
                _: 1,
                __: [12]
              }, 8, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue"]))
}